module.exports = __webpack_public_path__ + "img/Background.9ec07f8a.png";